export { default as Cafe } from './cafe.png';
export { default as Delivery } from './delivery.png';
export { default as DriversCouriers } from './drivers-couriers.png';
export { default as Education } from './education.png';
export { default as Entertainment } from './entertainment.png';
export { default as GasStations } from './gas-stations.png';

export { default as Hotels } from './hotels.png';
export { default as Nails } from './nails.png';
